<template>
  <div>
    <div class="container h-100">
      <div class="complete--container">
        <div class="img--container m-auto">
          <img src="@/assets/complete.svg" alt="complete" class="img-fluid">
        </div>
        <h3 class="text-center">We have successfully registered you as one of our Orbiters. Thank you for your courage in joining <span class="text-orange">Orbit Pathfinder "Discovery 1.0"</span>.</h3>
        <p class="text-lightgrey text-center">
          We will be in touch within the next 2-3 weeks. If you have any question,
          don't hesitate to reach out to us at our instagram <span class="text-orange">@pathfinder.orbit</span>. We'll see you very soon. Cheers!
        </p>
      </div>
    </div>
    <div class="footer">
      <small class="text-lightgrey text-center">Website by Faturachman Dwi Putro</small>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>